const translation = {
    PageSize: 'Taille de page',
    PageOrientation: 'Orientation de la page',
    Format: 'Format',
    DPI: 'DPI',
    Title: 'Exporter la carte',
    Close: 'Fermer',
    Save: 'Enregistrer',
    FileName: 'Nom du fichier',
    Landscape: 'Paysage',
    Portrait: 'Portrait',
    PreviewHint: 'Faites glisser pour déplacer, faites défiler ou pincez pour zoomer sur la zone à exporter.',
    ExportFailed: "L'export de la carte a échoué. Veuillez réessayer.",
    PreviewFailed: "Impossible d'afficher l'aperçu.",
    AdjustArea: 'Ajuster la zone sur la carte',
    AdjustAreaHint: 'Déplacez, zoomez, faites pivoter ou inclinez la carte pour cadrer la zone à exporter',
    ZoomIn: 'Zoom avant',
    ZoomOut: 'Zoom arrière',
    ResetZoom: 'Réinitialiser le zoom à 100 %',
    Done: 'Terminé',
    Cancel: 'Annuler',
    Scalebar: "Barre d'échelle",
    NorthIcon: 'Flèche du nord',
    ChooseNorthIcon: 'Choisir la flèche du nord',
    ChooseSvgFile: 'Choisir un fichier SVG',
    IconSymbol: 'Symbole',
    IconColor: 'Couleur',
    IconSize: 'Taille',
    InvalidSvg: 'Le fichier n’est pas un SVG valide.',
    ExportAsVector: 'Exporter en vectoriel',
    ExportLabelsAsVector: 'Exporter les étiquettes en vectoriel',
    Custom: 'Personnalisé',
    Width: 'Largeur',
    Height: 'Hauteur',
    LanguageName: 'Français',
    LanguageCode: 'fr'
};
export default translation;
